/* Change this file to get your personal Porfolio */

/**
 * How to update website every time you change the code:
 * 1. npm install (can be skipped if packages installed)
 * 2. NODE_OPTIONS=--openssl-legacy-provider npm run build
 * 3. cd build
 * 4. git init
 * 5. git remote add origin https://github.com/maxsye/maxsye.github.io.git
 * 6. git add .
 * 7. git commit -m "new build"
 * 8. git push -u origin main --force
 * 9. If it says authentication failed, use git push -u origin main and then enter your username and token. If you forgot your token generate a new one. Then login and do step 8
 * 
 * How to run website locally
 * 1. NODE_OPTIONS=--openssl-legacy-provider npm start
 * 
 * 
 * Use https://icon-sets.iconify.design to find icons
 * Use https://redketchup.io/color-picker to find icon colors (if needed)
 * Change src/assets/images/desc.png to change hover-over photo
 */



// Website related settings
const settings = {
  isSplash: false,
};

// SEO Related settings
const seo = {
  title: "Max Ye",
  description:
    "Max Ye's website",
  og: {
    title: "Max Ye",
    type: "website",
    url: "https://maxsye.github.io/",
  },
};

// Home Page
const greeting = {
  title: "Max Ye",
  logo_name: "Max Ye",
  nickname: "always_learning",
  subTitle:
  "Results-driven software engineer with experience in building scalable systems and driving complex technical initiatives to success",
  resumeLink:
    "https://drive.google.com/file/d/1qoSm3xm-CGVNeoAv2TLWRJnz5HqwqSaX/view?usp=sharing",
  portfolio_repository: "https://github.com/maxsye/portfolio",
  githubProfile: "https://github.com/maxsye",
};

const socialMediaLinks = [
  {
    name: "GitHub",
    link: "https://github.com/maxsye",
    fontAwesomeIcon: "fab fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/maxsye/",
    fontAwesomeIcon: "fab fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:maxsye2021@gmail.com",
    fontAwesomeIcon: "fas fa-envelope", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/maxsye2017/",
    fontAwesomeIcon: "fab fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
];

const skills = {
  data: [
    {
      title: "Data Science and AI/ML",
      fileName: "DataScienceImg",
      skills: [
        "• Conducted A/B and hypothesis testing, hyperparameter tuning, and cross-validation",
        "• Employed dimensionality reduction techniques like principal component analysis to enhance model performance",
        "• Performed nearest-neighbor classification, least-squares regression, and random forests prediction",
      ],
      softwareSkills: [
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos:numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "logos:pandas-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "devicon:scikitlearn",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Matplotlib",
          fontAwesomeClassname: "logos:matplotlib-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Seaborn",
          fontAwesomeClassname: "logos:seaborn-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Plotly",
          fontAwesomeClassname: "devicon:plotly",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "• Developed an education technology platform and enhanced a pharmaceutical toolkit with Django and PostgreSQL",
        "• Created modern web applications with the MERN (MongoDB, Express, React, Node) tech stack and JS package managers",
        "• Built iOS-and-Android-compatible mobile applications using Flutter",
      ],
      softwareSkills: [
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#092E20",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Node",
          fontAwesomeClassname: "vscode-icons:file-type-node",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa:css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "devicon:jquery",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "• Integrated AWS services like Lambda, S3, and DynamoDB to automate test summary report generation",
        "• Worked on numerous applications with Docker containerization, abstracting away build dependencies",
        "• Led 10+ engineers in Agile development with tools like Azure and GitHub",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Lambda",
          fontAwesomeClassname: "simple-icons:awslambda",
          style: {
            color: "#D9660B",
          },
        },
        {
          skillName: "S3",
          fontAwesomeClassname: "simple-icons:amazons3",
          style: {
            color: "#E35342",
          },
        },
        {
          skillName: "DynamoDB",
          fontAwesomeClassname: "simple-icons:amazondynamodb",
          style: {
            color: "#2272BA",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#F34F29",
          },
        },
        {
          skillName: "Github",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#171515",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "logos:jira",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "• Designed aesthetic user interfaces for mobile and web applications",
        "• Crafted graphics and illustrations from scratch",
        "• Optimized user experience by evaluating the user flow",
      ],
      softwareSkills: [
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Gimp",
          fontAwesomeClassname: "simple-icons:gimp",
          style: {
            color: "#543E41",
          },
        },
        {
          skillName: "Sketch",
          fontAwesomeClassname: "logos:sketch",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    // {
    //   siteName: "LeetCode",
    //   iconifyClassname: "simple-icons:leetcode",
    //   style: {
    //     color: "#F79F1B",
    //   },
    //   profileLink: "https://leetcode.com/layman_brother/",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of California, Berkeley",
      subtitle: "Bachelor's in Computer Science",
      logo_path: "berkeley_logo.png",
      alt_name: "University of California, Berkeley",
      duration: "August 2021 - December 2023",
      descriptions: [
        "• GPA: 3.94/4.00",
        "• Relevant coursework: CS 61A (Computer Programs), CS 61B (Data Structures), CS 61C (Machine Structures), CS 70 (Discrete Mathematics and Probability), DATA 100 (Data Science), CS 161 (Compute Security), CS 162 (Operating Systems), CS 170 (Algorithms), CS 186 (Database Systems)",
        "• Activities: UPE (Upsilon Pi Epsilon) International Honor Society for the Computing and Information Disciplines, CS 61B Course Staff, CS 186 Course Staff, Web Development at Berkeley, Computer Science Mentors",
      ],
      website_link: "https://www.berkeley.edu",
    },
    {
      title: "Adlai E. Stevenson High School",
      subtitle: "High School Diploma",
      logo_path: "stevenson_logo.png",
      alt_name: "Adlai E. Stevenson High School",
      duration: "August 2017 - May 2021",
      descriptions: [
        "• GPA: 4.0/4.0",
        "• Relevant coursework: AP Computer Science A, AP Computer Science Principles",
        "• Activities: Computer Science Club",
      ],
      website_link: "https://www.d125.org",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Flutter & Dart - The Complete Guide",
      subtitle: "- Udemy",
      logo_path: "udemy_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-85c4eaf7-e76e-4627-b578-6882137d293b/",
      alt_name: "Udemy",
      color_code: "#B8A5E9",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Jobs, Internships, and Academia",
  description:
    "Real-world experiences are invaluable, providing the playground in which I apply theory and concepts to create real change in the world around me.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Jobs",
      experiences: [
        {
          title: "Software Engineer",
          company: "Scale",
          company_url: "https://scale.com",
          logo_path: "scale_logo.png",
          duration: "March 2024 - Present",
          location: "San Francisco, CA",
          description: [
            "• Drove top-of-funnel expansion and platform reliability as a founding member of the Generative AI Growth Engineering team, supporting AI trainers at scale", 
            "• Led the complete redesign of Outlier AI user onboarding, increasing completion rate by 350% (to 45%) and slashing median onboarding time by 95% (to 1 hour) for 20K daily signups",
            "• Implemented comprehensive monitoring and testing on authentication logic, reducing signup errors from 12% to 0.1%",
            "• Built an email campaign platform with integrated A/B testing, automating sends based on user actions, delivering ~2M emails per week and boosting click-through rates by 34%",
            "• Architected the greenfield multi-touch attribution system with downstream user tracking and conversion reporting to ad platforms, enabling bid optimization and improving marketing ROI by 26%",
            "• Integrated multiple recruitment platforms, accounting for 17% of daily lead generation",
            "• Engineered a high-throughput onboarding event ingestion pipeline, guaranteeing strict order and data consistency for 100+ events per minute",
          ],
          color: "#7B91DE",
        },
        {
          title: "Founding Engineer",
          company: "Codeucate",
          company_url: "https://wecodeucate.org/",
          logo_path: "codeucate_logo.png",
          duration: "December 2019 - March 2024",
          location: "Vernon Hills, IL",
          description: [
            "• Founded a marketplace platform connecting 5K+ students with 100+ instructors in various live programming courses, achieving 60K+ instruction hours and a $1.5M valuation", 
            "• Designed and launched core infrastructure handling real-time scheduling, payments, and messaging, with up to 100 requests per second",
            "• Led team of 10+ engineers in Agile development of the Codeucate web app in Django, HTML & CSS, PostgreSQL, and Azure",
            "• Created an A/B experimentation framework, driving UI updates that tripled first-time course enrollment conversion rates (to 54%)",
            "• Optimized platform performance with caching strategies and database indexing, reducing page load times by 40%",
            "• Established best engineering practices, including design patterns and documentation standards, cutting engineer onboarding time by 25%",
            "• Enhanced the user experience with PayPal, Google Calendar, SendGrid, and Zoom API integrations",
          ],
          color: "#141C3A",
        },
        {
          title: "Software Development Engineer Intern",
          company: "Amazon",
          company_url: "https://www.amazon.com/",
          logo_path: "amazon_logo.png",
          duration: "May 2023 - August 2023",
          location: "Sunnyvale, CA",
          description: [
            "• Automated test summary report generation on Alexa-enabled third-party devices utilizing AWS services like DynamoDB, Lambda, and S3", 
            "• Developed unit and integration tests for existing testing processes with JUnit and Mockito, reaching 90% test coverage",
            "• Standardized category-specific test data into a unified schema, improving report consistency and cutting 50K+ lines of duplicated logic",
            ], 
          color: "#FF9900",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Development Engineer Intern",
          company: "Amazon",
          company_url: "https://www.amazon.com/",
          logo_path: "amazon_logo.png",
          duration: "May 2023 - August 2023",
          location: "Sunnyvale, CA",
          description: [
            "• Automated test summary report generation on Alexa-enabled third-party devices utilizing AWS services like DynamoDB, Lambda, and S3", 
            "• Developed unit and integration tests for existing testing processes with JUnit and Mockito, reaching 90% test coverage",
            "• Standardized category-specific test data into a unified schema, improving report consistency and cutting 50K+ lines of duplicated logic",
            ], 
          color: "#FF9900",
        },
        {
          title: "Full Stack Software Engineer Intern",
          company: "AbbVie",
          company_url: "https://www.abbvie.com/",
          logo_path: "abbvie_logo.png",
          duration: "August 2022 - May 2023",
          location: "Remote",
          description: [
            "• Leveraged ML in drug discovery, using NumPy, Pandas, and Scikit-learn for dimensionality reduction, cross-validation, and hyperparameter tuning",
            "• Augmented the lab material requisition platform with a quality control system, cutting down quality-related emails by 75%", 
            "• Visualized application usage data with Seaborn and Altair",
            ], 
          color: "#00003A",
        },
        {
          title: "Software Engineer Intern",
          company: "Allstate",
          company_url: "https://www.allstate.com/",
          logo_path: "allstate_logo.png",
          duration: "May 2022 - August 2022",
          location: "Remote",
          description: [
            "• Expanded Allstate’s Unstructured Data Platform (UDP) functionalities in consolidating all unstructured data (audio files, videos, and PDFs)",
            "• Designed a web app in React, Express, Next, and MongoDB to streamline client configuration creation for UDP’s API, serving 30K+ requests per hour",
            ], 
          color: "#004684",
        },
        {
          title: "Program Manager Intern",
          company: "Cisco",
          company_url: "https://www.cisco.com/",
          logo_path: "cisco_logo.png",
          duration: "May 2022 - August 2022",
          location: "San Jose, CA",
          description: [
            "• Facilitated the unification of internal policy and workflow for the entire portfolio of Cisco Secure products",
            "• Integrated Aha and Smartsheet product roadmap technologies using their respective REST APIs and Python, saving hundreds of hours of manual work",
            "• Launched a new entity-relationship model for program tracking",
            ], 
          color: "#049FD9",
        },
        {
          title: "Application Developer Intern",
          company: "AbbVie",
          company_url: "https://www.abbvie.com/",
          logo_path: "abbvie_logo.png",
          duration: "January 2022 - May 2022",
          location: "Remote",
          description: [
            "• Enhanced the personalization and navigation of NEST (Nexus of Electronic Scientific Tools), an internal research platform built with Django, Redis, PostgreSQL, Docker, and Jenkins, reducing search time by 50%", 
            "• Revamped the user interface in JavaScript, jQuery, HTML & CSS, and Sass",
            ], 
          color: "#00003A",
        },
      ],
    },
    {
      title: "Academia",
      experiences: [
        {
          title: "CS 186 (Database Systems) Teaching Assistant",
          company: "UC Berkeley Department of Electrical Engineering and Computer Sciences",
          company_url: "https://eecs.berkeley.edu",
          logo_path: "eecs_logo.jpg",
          duration: "August 2023 - December 2023",
          location: "Berkeley, CA",
          description: [
            "• Helped teach the upper-division course, with 500+ students enrolled, under Professor Alvin Cheung", 
            "• Covered foundational database topics like B+ trees, concurrency, recovery, parallel query processing, and distributed transactions",
            "• Moderated the course forum, broadcasted announcements, and answered 500+ questions",
          ],
          color: "#003362",
        },
        {
          title: "CS 61B (Data Structures) Teaching Assistant",
          company: "UC Berkeley Department of Electrical Engineering and Computer Sciences",
          company_url: "https://eecs.berkeley.edu",
          logo_path: "eecs_logo.jpg",
          duration: "August 2022 - May 2023",
          location: "Berkeley, CA",
          description: [
            "• Served on the course staff of UC Berkeley's classic data structures course, with 1200+ students enrolled, under Professor Josh Hug", 
            "• Held weekly small group discussion sections on a variety of concepts like inheritance, polymorphism, disjoint sets, and asymptotics",
            "• Conducted meetings to provide reasonable accomodations to students as part of the Student Support team",
          ],
          color: "#003362",
        },
        {
          title: "CS 61BL (Data Structures & Programming Methodology) Teaching Assistant",
          company: "UC Berkeley Department of Electrical Engineering and Computer Sciences",
          company_url: "https://eecs.berkeley.edu",
          logo_path: "eecs_logo.jpg",
          duration: "June 2022 - August 2022",
          location: "Berkeley, CA",
          description: [
            "• Assisted the summer iteration of UC Berkeley's CS 61B, with 450+ students enrolled", 
            "• Taught four 3-hour labs a week on hashing, sorting, trees, graphs, unit and integration testing",
            "• Supported course infrastructure and enhanced course curriculum",
          ],
          color: "#003362",
        },
        {
          title: "SEED Scholar Tutor",
          company: "UC Berkeley SEED Scholar Honors Program",
          company_url: "https://seedscholars.berkeley.edu/",
          logo_path: "seed_logo.png",
          duration: "January 2022 - May 2022",
          location: "Berkeley, CA",
          description: [
            "• Tutored students from historically marginalized populations in the STEM Excellence through Equity & Diversity (SEED) Program", 
            "• Taught 1-hour weekly sections on EECS 16B (Designing Information Devices and Systems II), covering circuit theory, signal processing, and controllability",
          ],
          color: "#C4841C",
        },
        // {
        //   title: "Socials Chair and Junior Mentor",
        //   company: "Computer Science Mentors",
        //   company_url: "https://csmentors.berkeley.edu/#/",
        //   logo_path: "csm_logo.png",
        //   duration: "January 2022 - December 2023",
        //   location: "Berkeley, CA",
        //   description: [
        //     "• Held 1-hour sessions for 6 students twice a week", 
        //     "• Reviewed CS 70 (Discrete Math and Probability Theory) topics: proofs, graph theory, encryption",
        //     "• Explained course material through mini-lectures and relevant practice problems",
        //   ],
        //   color: "#AFE4C2",
        // },
        // {
        //   title: "Scholarship Chairman",
        //   company: "Theta Xi Fraternity",
        //   company_url: "http://thetaxi.org/",
        //   logo_path: "theta_xi_logo.png",
        //   duration: "August 2021 - December 2021",
        //   location: "Berkeley, CA",
        //   description: [
        //     "• Responsible for the upkeep of chapter's academic progress",
        //     "• Hosted academic success workshops", 
        //     "• Implemented policies like social probation and study hours",
        //     "• Theta Xi's GPA of 3.599 exceeded CalGreeks (3.486) and of the Berkeley population as a whole (3.497)",
        //   ],
        //   color: "#0958A3",
        // },
        // {
        //   title: "Computer Science Teacher",
        //   company: "Fenghua Academy",
        //   company_url: "https://www.fenghuaschool.org/",
        //   logo_path: "fenghua_logo.png",
        //   duration: "August 2017 - May 2021",
        //   location: "Lake Zurich, IL",
        //   description: [
        //     "• Taught Python and Java computer programming at the Sunday Chinese school", 
        //     "• Developed lesson plans and curriculum",
        //     "• Instructed 60+ students",
        //   ],
        //   color: "#EB121B",
        // },
        // {
        //   title: "English Teacher",
        //   company: "Fenghua Academy",
        //   company_url: "https://www.fenghuaschool.org/",
        //   logo_path: "fenghua_logo.png",
        //   duration: "June 2018 - August 2018",
        //   location: "Suzhou, China",
        //   description: [
        //     "• Led group of 20 volunteers",
        //     "• Communicated feedback from volunteers to the supervisor, coordinated a dance for the closing ceremony, created fun classroom activities",
        //     "• Volunteered for 200 hours in total, in addition to preparing teaching material beforehand"
        //   ],
        //   color: "#EB121B",
        // },
        // {
        //   title: "Summer Reading Club Volunteer",
        //   company: "Vernon Area Public Library",
        //   company_url: "https://www.vapld.info/",
        //   logo_path: "vapld_logo.png",
        //   duration: "May 2017 - August 2019",
        //   location: "Lincolnshire, IL",
        //   description: [
        //     "• Volunteered at the local library on weekends to support the summer reading program",
        //     "• Logged students' progress, handed out prizes, staffed program events",
        //   ],
        //   color: "#01BDE2",
        // },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "A curated collection of personal and school projects.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "max_ye.png",
    description:
      "Always looking to solve challenging problems -- feel free to reach out!",
  },
  blogSection: {
    title: "My Blog",
    subtitle:
      "Exploring my all-consuming passion outside of tech: health and wellness",
    link: "https://maxye.net/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "San Francisco, CA",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/San+Francisco,+CA/@37.7575853,-122.6024091,11z/data=!3m1!4b1!4m6!3m5!1s0x80859a6d00690021:0x4a501367f076adff!8m2!3d37.7749295!4d-122.4194155!16zL20vMGQ2bHA?entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoJLDEwMjExNjM5SAFQAw%3D%3D",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "847-477-3818",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};